export enum LearnerAction {
  CancelInvite = 'CANCEL_INVITE',
  ViewProfile = 'VIEW_PROFILE',
  EditProfile = 'EDIT_PROFILE',
  Assign = 'ASSIGN',
  DeactivateStaff = 'DEACTIVATE_STAFF',
  DeactivateLearner = 'DEACTIVATE_LEARNER',
  ReactivateLearner = 'REACTIVATE_LEARNER',
  ReActivate = 'RE_ACTIVATE',
  EditTags = 'EDIT_TAGS',
  EditRole = 'EDIT_ROLE',
  ShareLearnerProfile = 'SHARE_LEARNER_PROFILE',
  Masquerade = 'MASQUERADE',
  ResendInvite = 'RESEND_INVITE',
  MergeAccount = 'MERGE_ACCOUNT',
}

export enum DialogAndModalAction {
  Close = 'CLOSE',
  Deactivate = 'DEACTIVATE',
}

export enum LearnerPageFilters {
  DEFAULT = 'DEFAULT',
  STAFF = 'STAFF',
}

export enum LearnerStatusFilters {
  ACTIVE = 'active',
  PENDING = 'pending',
  DEACTIVATED = 'deactivated',
}

export interface LearnerPageProps {
  filter: LearnerPageFilters; // todo: remove filter
  status: LearnerStatusFilters;
}

export enum ActionModalAndDialogs {
  Tags = 'TAGS',
  EditProfile = 'EDIT_PROFILE',
  DeactivateStaff = 'DEACTIVATE_STAFF',
  DeactivateLearner = 'DEACTIVATE_LEARNER',
  ReactivateLearner = 'REACTIVATE_LEARNER',
  Deactivate = 'DEACTIVATE',
  Masquerade = 'MASQUERADE',
  CannotDeactivateOwner = 'CANNOT_DEACTIVATE_OWNER',
  MergeAccount = 'MERGE_ACCOUNT',
}

export enum LearnersActions {
  BulkImport = 'BULK_IMPORT',
  BulkExport = 'BULK_EXPORT',
  InviteExternalLearners = 'INVITE_EXTERNAL_LEARNERS',
  ResendInvitations = 'RESEND_INVITATIONS',
}

export enum LearnersActionsDialogs {
  BulkImport = 'BULK_IMPORT',
  BulkExport = 'BULK_EXPORT',
  InviteExternalLearners = 'INVITE_EXTERNAL_LEARNERS',
  ResendInvitations = 'RESEND_INVITATIONS',
}
